<template>
  <div
    v-bind:class="{
      navigationButtonWrapper: true,
      light: theme === 'light',
      dark: theme === 'dark'
    }"
    v-on:click="redirect"
  >
    <img :src="icon" alt="" />
  </div>
</template>

<script>

export default {
  name: 'NavigationButton',
  props: ['theme', 'icon', 'action'],
  data() {
    return {
    }
  },
  methods: {
    redirect: function () {
      console.log(`app-action:${this.action}`);
    }
  },

  created() {
  }
}
</script>

<style lang="scss">
  .navigationButtonWrapper {
    width: 2.75rem;
    height: 2.75rem;
    display: inline-flex;
    background-color: rgba(255, 255, 255, 0.4);
    background-size: 50%;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 100%;
    justify-content: center;
    align-items: center;


    img {
      width: 90%;
      height: 90%;
    }
  }

  .navigationButtonWrapper:active {
    opacity: 0.7;
  }

  .navigationButtonWrapper.dark {
  }

  .navigationButtonWrapper.light {
  }

</style>
